<div class="row-chips">
  <su-chip [items]="chips" (onRemove)="handleOnRemoveChip($event)"></su-chip>
</div>

<ng-template #toolbarTpl>
  <su-slot-controls
    mainTLabel="Filter"
    [buttons]="controlButtons"
    [dialogData]="dialogData"
    [modal]="modalComponent"></su-slot-controls>
</ng-template>

<mtx-grid
  [columns]="columns"
  [columnResizable]="config.columnResizable"
  [data]="filteredData ?? []"
  [length]="totalCount ?? filteredData?.length ?? 0"
  [pageOnFront]="config.pageOnFront"
  [pageSizeOptions]="config.pageSizeOptions"
  [hidePageSize]="config.hidePageSize"
  [pageSize]="config.pageSize"
  [pageIndex]="config.pageIndex"
  (page)="changePage($event)"
  [sortOnFront]="config.sortOnFront"
  (sortChange)="sortChange($event)"
  [loading]="isLoading"
  [rowStriped]="true"
  [noResultText]="'grid.no_results' | translate"
  (rowClick)="rowClick.emit($event)"
  (refresh)="refreshData.emit($event)"
  [rowHover]="true"
  [cellSelectable]="false"
  [showPaginator]="config.showPaginator"
  [showColumnMenuButton]="config.showColumnMenu"
  [columnMenuButtonText]="'grid.columns_shown' | translate"
  [columnMenuHeaderText]="'grid.columnMenuHeaderText' | translate"
  columnMenuButtonClass="col-button"
  columnMenuButtonType="flat"
  [columnHideable]="true"
  [columnHideableChecked]="'show'"
  [columnPinnable]="false"
  [columnSortable]="true"
  [showToolbar]="config.showToolbar"
  [showSidebar]="true"
  [rowSelectable]="config.rowSelectable"
  [multiSelectable]="config.multiSelectable"
  (rowSelectedChange)="rowSelectedChange.emit($event)"
  [rowSelected]="selection | async"
  [hideRowSelectionCheckbox]="false"
  [toolbarTemplate]="toolbarTpl"
  [expandable]="config.expandable"
  [expansionTemplate]="expansionTemplate"
  [headerTemplate]="headerTemplate">
</mtx-grid>
